module.exports = "<nav-bar></nav-bar>\r\n<div class=\"container\">\r\n\t<router-outlet></router-outlet>\r\n\t<alert></alert>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = 0